import { useState } from 'react'

const capitalize = (s) => s ? s.charAt(0).toUpperCase() + s.slice(1) : ''

const getImageSrc = (item) => {
  const k = item.item_key
  switch (item.category) {
    case 'character':  return `/assets/avatar/characters/${capitalize(k)}.png`
    case 'skin':       return `/assets/avatar/clothes/${k}/${k}-thumb.png`
    case 'hat':        return `/assets/avatar/hats/${k}-thumb.png`
    case 'hand_item':  return `/assets/avatar/hand-items/${k}-thumb.png`
    case 'background': return `/assets/avatar/backgrounds/${k}.svg`
    default:           return ''
  }
}

const CartItemThumb = ({ item }) => {
  const [err, setErr] = useState(false)
  const src = getImageSrc(item)

  if (err || !src) {
    return (
      <div style={{ width: 44, height: 44, borderRadius: 12, background: '#EEF2FF', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
        <img src={CATEGORY_EMOJI[item.category]} alt={item.category} style={{ width: 24, height: 24, objectFit: 'contain' }} />
      </div>
    )
  }

  return (
    <img
      src={src}
      alt={item.item_name}
      onError={() => setErr(true)}
      style={{ width: 44, height: 44, borderRadius: 12, objectFit: 'cover', background: '#F4F7FF', flexShrink: 0 }}
    />
  )
}

const ShopCart = ({ cart, coins, gems, onRemove, onBuy, buying, error, previewCharacter }) => {
  const coinItems = cart.filter(i => i.category !== 'skin')
  const gemItems  = cart.filter(i => i.category === 'skin')
  const coinTotal = coinItems.reduce((s, i) => s + i.price_coin, 0)
  const gemTotal  = gemItems.reduce((s, i) => s + (i.price_gem || 0), 0)
  const hasCoinItems = coinItems.length > 0
  const hasGemItems  = gemItems.length > 0
  const canBuyCoins = hasCoinItems && coins >= coinTotal
  const canBuyGems  = hasGemItems  && gems  >= gemTotal

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      {/* 헤더 */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <p style={{ margin: 0, fontSize: 15, fontWeight: 800, color: '#0D2A4F' }}>My Cart</p>
        {cart.length > 0 && (
          <div style={{ width: 26, height: 26, borderRadius: '50%', background: '#4F6BED', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 800, color: '#fff' }}>
            {cart.length}
          </div>
        )}
      </div>

      {/* 카트 아이템 목록 */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, minHeight: 80 }}>
        {cart.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '24px 0', color: '#B0BBC8', fontSize: 13 }}>
            <p style={{ margin: '0 0 4px', fontSize: 28 }}>🛒</p>
            <p style={{ margin: 0 }}>Cart is empty</p>
          </div>
        ) : (
          cart.map((item) => (
            <div key={item.id} style={{ display: 'flex', alignItems: 'center', gap: 12, background: '#F8FBFF', border: '1.5px solid #E7ECF3', borderRadius: 18, padding: '10px 12px', transition: 'background .15s' }}>
              <CartItemThumb item={item} previewCharacter={previewCharacter} />
              <div style={{ flex: 1, minWidth: 0 }}>
                <p style={{ margin: 0, fontSize: 14, fontWeight: 700, color: '#0D2A4F', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.item_name}</p>
                <div style={{ display: 'flex', alignItems: 'center', gap: 4, marginTop: 3 }}>
                  {item.category === 'skin' ? (
                    <>
                      <img src="/assets/icons/gem.png" alt="gem" style={{ width: 13, height: 13, objectFit: 'contain' }} />
                      <span style={{ fontSize: 13, fontWeight: 700, color: '#9B59B6' }}>{item.price_gem}</span>
                    </>
                  ) : (
                    <>
                      <img src="/assets/icons/coin.png" alt="coin" style={{ width: 13, height: 13, objectFit: 'contain' }} />
                      <span style={{ fontSize: 13, fontWeight: 700, color: '#7A889B' }}>{item.price_coin}</span>
                    </>
                  )}
                </div>
              </div>
              <button
                onClick={() => onRemove(item.id)}
                style={{ width: 28, height: 28, borderRadius: '50%', background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, color: '#8B9AB0', flexShrink: 0, transition: 'color .15s' }}
                onMouseEnter={e => e.currentTarget.style.color = '#DC2626'}
                onMouseLeave={e => e.currentTarget.style.color = '#8B9AB0'}
              >
                ×
              </button>
            </div>
          ))
        )}
      </div>

      {/* Total + 버튼 */}
      {cart.length > 0 && (
        <>
          <div style={{ padding: '14px 0', borderTop: '1px solid #E7ECF3', display: 'flex', flexDirection: 'column', gap: 6 }}>
            {hasCoinItems && (
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: 14, fontWeight: 700, color: '#7A889B' }}>Coins</span>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                  <img src="/assets/icons/coin.png" alt="coin" style={{ width: 18, height: 18, objectFit: 'contain' }} />
                  <span style={{ fontSize: 20, fontWeight: 900, color: '#0D2A4F' }}>{coinTotal.toLocaleString()}</span>
                </div>
              </div>
            )}
            {hasGemItems && (
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: 14, fontWeight: 700, color: '#7A889B' }}>Gems</span>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                  <img src="/assets/icons/gem.png" alt="gem" style={{ width: 18, height: 18, objectFit: 'contain' }} />
                  <span style={{ fontSize: 20, fontWeight: 900, color: '#0D2A4F' }}>{gemTotal.toLocaleString()}</span>
                </div>
              </div>
            )}
          </div>

          {error && (
            <div style={{ background: '#FEF2F2', border: '1px solid #FECACA', borderRadius: 12, padding: '10px 14px', fontSize: 13, color: '#DC2626', fontWeight: 600 }}>
              {error}
            </div>
          )}

          {hasCoinItems && (
            <button
              onClick={() => onBuy('coin')}
              disabled={buying || !canBuyCoins}
              style={{
                width: '100%', padding: '15px', border: 'none', borderRadius: 16,
                background: canBuyCoins ? 'linear-gradient(135deg,#5674F4,#3E5AD7)' : '#D1D9F0',
                color: '#fff', fontSize: 16, fontWeight: 800,
                cursor: canBuyCoins && !buying ? 'pointer' : 'not-allowed',
                boxShadow: canBuyCoins ? '0 8px 20px rgba(79,107,237,.25)' : 'none',
                transition: 'opacity .15s, transform .15s',
                opacity: buying ? 0.7 : 1,
              }}
              onMouseEnter={e => { if (canBuyCoins && !buying) e.currentTarget.style.transform = 'translateY(-1px)' }}
              onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)' }}
            >
              {buying === 'coin' ? 'Buying…' : !canBuyCoins
                ? <><span>Need {(coinTotal - coins).toLocaleString()} more </span><img src="/assets/icons/coin.png" alt="coin" style={{ width: 14, height: 14, objectFit: 'contain', verticalAlign: 'middle' }} /></>
                : <><img src="/assets/icons/coin.png" alt="coin" style={{ width: 14, height: 14, objectFit: 'contain', verticalAlign: 'middle', marginRight: 6 }} />Buy with Coins</>}
            </button>
          )}

          {hasGemItems && (
            <button
              onClick={() => onBuy('gem')}
              disabled={buying || !canBuyGems}
              style={{
                width: '100%', padding: '14px', borderRadius: 16,
                background: canBuyGems ? '#fff' : '#F8F8F8',
                color: canBuyGems ? '#8F70AE' : '#B0BBC8',
                border: `2px solid ${canBuyGems ? '#C4A8F0' : '#E0E0E0'}`,
                fontSize: 15, fontWeight: 800,
                cursor: canBuyGems && !buying ? 'pointer' : 'not-allowed',
                transition: 'opacity .15s, transform .15s',
                opacity: buying ? 0.7 : 1,
              }}
              onMouseEnter={e => { if (canBuyGems && !buying) e.currentTarget.style.transform = 'translateY(-1px)' }}
              onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)' }}
            >
              {buying === 'gem' ? 'Buying…' : !canBuyGems
                ? <><span>Need {(gemTotal - gems).toLocaleString()} more </span><img src="/assets/icons/gem.png" alt="gem" style={{ width: 14, height: 14, objectFit: 'contain', verticalAlign: 'middle' }} /></>
                : <><img src="/assets/icons/gem.png" alt="gem" style={{ width: 14, height: 14, objectFit: 'contain', verticalAlign: 'middle', marginRight: 6 }} />Buy with Gems</>}
            </button>
          )}
        </>
      )}

      {/* 하단 프로모 배너 */}
      <div style={{
        marginTop: 'auto',
        background: 'linear-gradient(135deg,#FFF9E6,#FFF3CC)',
        borderRadius: 18,
        padding: '14px 16px',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        overflow: 'hidden',
        position: 'relative',
      }}>
        <p style={{ margin: 0, fontSize: 13, fontWeight: 700, color: '#92400E', lineHeight: 1.5, flex: 1, zIndex: 1 }}>
          Keep learning and<br />earn more Coins!
        </p>
        <img
          src="/assets/avatar/coin-banner.png"
          alt=""
          style={{ width: 80, height: 80, objectFit: 'contain', flexShrink: 0 }}
        />
      </div>
    </div>
  )
}

const CATEGORY_EMOJI = {
  character:  '/assets/icons/category-character.png',
  skin:       '/assets/icons/category-skin.png',
  hat:        '/assets/icons/category-hat.png',
  hand_item:  '/assets/icons/pencil.png',
  background: '/assets/icons/category-background.png',
}

export default ShopCart
